import type { DayCenterSchedule } from '@seen/core/models/schedules/dayCenterSchedule'
import { Label } from '@seen/ui'
import type { JSX } from 'react'
import {
  daysPerWeekLabel,
  formatAttendanceDays,
} from '#src/components/patient/detail-content/day-center-schedule/weekdays.ts'

export interface CarePlanDayCenterScheduleSummaryProps {
  schedule: DayCenterSchedule | null | undefined
  onClick?: () => void
}

export function CarePlanDayCenterScheduleSummary({
  schedule,
  onClick,
}: CarePlanDayCenterScheduleSummaryProps): JSX.Element {
  const days = schedule?.attendanceDays ?? []
  const note = schedule?.note?.trim()
  const scheduleText =
    days.length > 0
      ? `${daysPerWeekLabel(days.length)} (${formatAttendanceDays(days)})`
      : 'No days set'
  const summaryText = note ? `${scheduleText}, ${note}` : scheduleText
  const content =
    schedule === undefined ? (
      <span className="text-muted-foreground">Loading schedule…</span>
    ) : schedule === null ? (
      <span className="text-muted-foreground">
        No day center schedule recorded.
      </span>
    ) : (
      <span className="whitespace-pre-wrap">{summaryText}</span>
    )

  return (
    <div className="flex flex-col text-sm">
      <Label className="pb-2">Day Center Attendance</Label>
      {onClick ? (
        <button
          type="button"
          onClick={onClick}
          disabled={schedule === undefined}
          className="block w-full rounded-sm text-left hover:underline focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-hidden disabled:pointer-events-none disabled:no-underline"
        >
          {content}
        </button>
      ) : (
        content
      )}
    </div>
  )
}
